import React from 'react';
import ServicesChartsDataProvider from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { subtitlesMap } from '../../Common/maps/subtitleMap';
import { QUERY_KEYS_SIH } from '../../../Common/hooks/useChartsData';
import GeneralResultsAIH from './GeneralResults';

const GeneralResultsWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'do Total de AIH'
            }}
            queryConfig={{
                key: QUERY_KEYS_SIH.GENERAL_RESULTS_AIH,
                url: 'governanceroom/dashboard/sihsus/aih/generalResults'
            }}
            subtitlesMap={subtitlesMap}
        >
            <GeneralResultsAIH />
        </ServicesChartsDataProvider>
    );
};

export default GeneralResultsWrapper;
